export const manager = {
    namespaced: true,
    state: {
      module: '',
      displayModuleUrl: 'iot',
      displayModuleName: 'display',
      bookModuleUrl: 'liftbook',
      bookModuleName: 'book',
      settingsModule: 'settings',
      settingsModuleUrl:'settings'
    },
    mutations: {
      changeModule(state, module) {
        state.module = module;
      }
    }

  }
